module.exports = __webpack_public_path__ + "assets/img/44.ac5f097b.png";